(function($) { 
	$(document).ready(function(){
        $(".size-opener").click(function(){
            $("body").addClass("size-active"); return false;
        });
      
        $(".size-overlay").on('click',function(){
            $("body").removeClass("size-active"); return false;
        });
      
       $(".cart-close").click(function(){
            $(".quick-cart").removeClass("active visible");
            $('body').css('overflow', '');
        });

      $(".filter-menu .pt-mobile-header a.pt-nav-toggle").click(function(){
            $(this).toggleClass("active"); return false;
        });

      $(".filter-menu .pt-mobile-header a.pt-nav-toggle").click(function(){
            $(this).parent().parent().toggleClass("filter-mobile-active"); return false;
        });

      $(".filter-group-size").click(function(){
            $(this).toggleClass("filter-size-active");
        });
      
       /* $(".header__links-list > li").hover(function(){
            $(this).toggleClass("nav-active"); return false;
        }); */
      
        $(".collection-filter-menu summary").click(function(){
          if($(this).closest("details").attr("open")) {
            $(this).closest("details").removeAttr("open");
          } else {
            $(this).closest("details").attr("open", true)
          }
        })
    }); 
})(jQuery);